import React, { useContext } from "react";

import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  Tooltip,
  Bar,
} from "recharts";

import { Typography } from "clearsense-ui/components";
import ThemeContext from "contexts/ThemeContext";

import OffsetBar from "./OffsetBar";

const Chart = ({ title, data }) => {
  const { theme } = useContext(ThemeContext);
  const formatTooltipValue = value => value.toLocaleString();

  const formatTooltipLabel = value =>
    value === 100 ? `${value}%` : `${value}% - ${value + 10}%`;

  return (
    <div className="flex flex-col bg-white dark:bg-gray-800 border-2 col-span-full h-96">
      <Typography
        style="h4"
        type="semibold"
        className="flex-none px-6 py-4 border-b-2"
      >
        {title}
      </Typography>
      <div className="flex-1 p-4 pb-0">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={450}
            height={350}
            barCategoryGap="0%"
            data={data}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
            <CartesianGrid stroke="#f5f5f5" />
            <XAxis
              dataKey="name"
              scale="point"
              unit="%"
              stroke={theme === "dark" ? "#f5f5f5" : "#666666"}
            />
            <Tooltip
              formatter={formatTooltipValue}
              labelFormatter={formatTooltipLabel}
              offset={100}
            />
            <Bar
              dataKey="count"
              barSize="100%"
              fill="#6EE7B7"
              shape={<OffsetBar />}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Chart;
